import { $getRoot, createCommand } from 'lexical';
import { useEffect, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export const IS_EDITOR_EMPTY = createCommand<{ isEditorEmpty: boolean }>(
  'IS_EDITOR_EMPTY',
);

export function OnChangesPlugin({
  setContent,
}: {
  setContent: (content: string) => void;
}) {
  const [isEditorEmpty, setIsEditorEmpty] = useState(false);
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unreg = editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const plainText = $getRoot().getTextContent();
        setContent(plainText);

        setIsEditorEmpty(plainText.trim() === '');
      });
    });

    return () => unreg();
  }, [editor, setContent]);

  useEffect(() => {
    editor.dispatchCommand(IS_EDITOR_EMPTY, { isEditorEmpty });
  }, [editor, isEditorEmpty]);

  return null;
}
